{
  "title": "Contacto del Asesor",
  "pageConfigurationInfo": "Las opciones de visualización del widget de Contacto del Asesor (nombre, teléfono, correo electrónico, dirección y los interruptores relacionados) se configuran por página en",
  "noAccess": "Usted no tiene permiso para ver la administración de Contacto del Asesor.",
  "comingSoon": "Próximamente",
  "none": "— ninguno —",
  "noneOption": "— Ninguno —",
  "required": "* Obligatorio",
  "tabs": {
    "repCodeManagement": "Gestión de Códigos de Representante",
    "roleLibrary": "Biblioteca de Roles",
    "userProfile": "Perfil de Usuario",
    "advisorContact": "Contacto del Asesor",
    "clientView": "Vista del Cliente"
  },
  "repCodeManagement": {
    "title": "Gestión de Códigos de Representante",
    "description": "El código y el nombre son editables aquí. Los usuarios asignados son el acceso, configurado en el perfil de usuario de cada persona. La designación de qué contacto de asesor representa un código se establece en la pestaña Contacto del Asesor.",
    "designationNote": "La designación está limitada al registro de contacto del asesor, por lo que se gestiona en la pestaña Contacto del Asesor en lugar de aquí."
  },
  "roleLibrary": {
    "title": "Biblioteca de Roles del Asesor",
    "description": "El orden establece la prioridad de visualización. Cree, cambie el nombre, elimine y reordene localmente, luego guarde para aplicar. Los registros sin rol asignado siempre se ordenan después de cada rol aquí. Al heredar de la organización principal, la biblioteca es de solo lectura y esta organización no tiene roles locales propios.",
    "addRole": "Agregar Rol",
    "newRoleName": "Nuevo Rol",
    "roleName": "Nombre del rol",
    "rankPrefix": "Rango",
    "dragHandle": "Arrastrar para reordenar",
    "deleteRole": "Eliminar rol",
    "dirtyNote": "Usted tiene cambios sin guardar",
    "saveChanges": "Guardar Cambios",
    "saveFailed": "No se pudieron guardar los cambios de la biblioteca de roles",
    "nameRequired": "Ingrese un nombre de rol",
    "nameDuplicate": "Otro rol ya utiliza este nombre",
    "emptyState": "Aún no hay roles. Agregue un rol para comenzar a construir la biblioteca.",
    "inherited": "Heredado",
    "useParentDisplayRoles": "Heredar roles de visualización de la organización principal",
    "inheritModal": {
      "turnOnTitle": "¿Heredar roles de la organización principal?",
      "turnOnBody": "Los roles propios de esta organización se archivarán y se reemplazarán por la biblioteca de solo lectura de la organización principal. Mientras hereda, usted no puede agregar, renombrar, reordenar o eliminar roles.",
      "rolesArchived": "rol(es) local(es) se archivará(n)",
      "contactsReset": "contacto(s) de asesor tendrá(n) su rol de visualización restablecido a vacío",
      "turnOnNoImpact": "Esta organización no tiene roles locales, por lo que no se archivará nada.",
      "turnOffTitle": "¿Dejar de heredar roles?",
      "turnOffBody": "La biblioteca de roles de esta organización estará vacía hasta que usted la reconstruya desde cero. Nada se copia de la organización principal.",
      "turnOffImpact": "Cada contacto de asesor y usuario actualmente asignado a un rol principal lo tendrá restablecido a vacío — en esta organización y en cada organización secundaria que herede de ella.",
      "confirm": "Continuar"
    },
    "deleteModal": {
      "title": "¿Eliminar este rol?",
      "inUse": "Al eliminar este rol, se restablecerá el rol de visualización a vacío en cada Contacto del Asesor que lo tenga actualmente cuando usted guarde. Esto no se puede deshacer.",
      "notInUse": "Nadie está utilizando este rol actualmente. Es seguro eliminarlo.",
      "advisorContacts": "contacto(s) de asesor",
      "confirm": "Eliminar Rol"
    },
    "saveModal": {
      "title": "¿Guardar biblioteca de roles?",
      "body": "Las creaciones, los cambios de nombre, las eliminaciones y el nuevo orden de visualización se aplicarán inmediatamente para cada Contacto del Asesor y widget de cliente que utilice estos roles."
    }
  },
  "userProfile": {
    "title": "Perfil de Usuario",
    "description": "El nombre, correo electrónico, teléfono, idioma, rol y tipo de acceso se gestionan aquí como lo son hoy. Los códigos de representante en un usuario son acceso, y son de lo que se calculan tanto los usuarios asignados de Gestión de Códigos de Representante como la verificación de conexión de la Vista del Cliente.",
    "displayRoleComingSoon": "Rol de Visualización — una etiqueta de respaldo por usuario obtenida de la Biblioteca de Roles, mostrada solo cuando un usuario no es el contacto de asesor designado de la cuenta. Aún no disponible en el perfil de usuario."
  },
  "contacts": {
    "title": "Contacto del Asesor",
    "description": "La identidad canónica y orientada al cliente: nombre, teléfono, correo electrónico, dirección y rol de visualización. Agregue uno manualmente para asesores sin acceso al sistema, o vincule un perfil de usuario — la vinculación inicializa el nombre, teléfono y correo electrónico una vez desde ese usuario, luego este registro se edita de forma independiente y nunca se revierte. Use Designado Para para elegir qué código(s) de representante representa esta identidad en la Vista del Cliente.",
    "addManual": "Agregar Contacto del Asesor (manual)",
    "newFirstName": "Nuevo",
    "newLastName": "Asesor",
    "columns": {
      "name": "Nombre",
      "linkedUser": "Usuario Vinculado",
      "phone": "Teléfono",
      "email": "Correo electrónico",
      "address": "Dirección",
      "displayRole": "Rol de Visualización",
      "designatedFor": "Designado Para"
    },
    "firstName": "Nombre",
    "lastName": "Apellido",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "address": "Dirección",
    "displayRole": "Rol de Visualización",
    "designatedFor": "Designado Para",
    "linkedUserNone": "— Ninguno (manual) —",
    "inherited": "Heredado",
    "override": "Anular",
    "designate": "Designar…",
    "designateSaveLinkFirst": "Guarde el cambio de usuario vinculado antes de editar los códigos de representante designados.",
    "undesignate": "Eliminar designación",
    "emptyState": "Aún no hay contactos de asesor. Agregue uno manualmente o vincule un usuario existente.",
    "firstNameRequired": "Ingrese un nombre",
    "saveFailed": "No se pudo guardar el contacto del asesor",
    "deleteFailed": "No se pudo eliminar el contacto del asesor",
    "overrideFailed": "No se pudo crear una anulación local",
    "useParentAdvisorContacts": "Mostrar contactos de asesor de organizaciones principales",
    "modal": {
      "createTitle": "Agregar contacto del asesor",
      "editTitle": "Editar contacto del asesor"
    },
    "deleteModal": {
      "title": "¿Eliminar este contacto del asesor?",
      "confirm": "Eliminar",
      "body": "Esto archivará a {{name}} y liberará cualquier código de representante designado. Esto no se puede deshacer."
    },
    "inheritModal": {
      "turnOnTitle": "¿Mostrar contactos de asesor de la organización principal?",
      "turnOnBody": "Los contactos de asesor de las organizaciones principales serán visibles para los clientes de esta organización.",
      "turnOffTitle": "¿Dejar de mostrar contactos de asesor de la organización principal?",
      "turnOffBody": "Los contactos de asesor de las organizaciones principales ya no serán visibles para los clientes de esta organización.",
      "turnOffDescendants": "Las organizaciones secundarias que heredan de esta organización también se ven afectadas.",
      "confirm": "Continuar",
      "turnOffCount": "contacto(s) de asesor heredado(s) en esta página ya no serán visibles para los clientes."
    },
    "pruneModal": {
      "title": "Algunas designaciones serán eliminadas",
      "body": "El usuario recién vinculado no posee estos códigos, por lo que se eliminarán:",
      "confirm": "Continuar"
    },
    "extension": "Extensión",
    "manualIdentity": "Gestionado",
    "emptyStateBrokenFilter": "Ningún asesor inactivo coincide con este filtro.",
    "brokenFilter": "Mostrar solo asesores inactivos",
    "brokenIndicator": "Inactivo",
    "departedSuffix": "(inactivo)",
    "brokenDesignationDisabled": "Las designaciones no están disponibles mientras el usuario vinculado esté inactivo. Vuelva a vincular este contacto a un usuario activo o desvincúlelo primero.",
    "brokenNotice": {
      "title": "El usuario vinculado ya no está activo",
      "body": "Este usuario vinculado ha partido o ha sido desactivado, por lo que este contacto ya no está vinculado a un usuario activo. Vuelva a vincularlo a un usuario activo a continuación, o desvincúlelo para mantenerlo como una identidad manual. Sus códigos de representante designados ya han sido eliminados.",
      "unlink": "Desvincular",
      "unlinkPending": "Este contacto se desvinculará y se mantendrá como una identidad manual cuando guarde.",
      "unknownUser": "El usuario vinculado de este asesor",
      "inheritedResolve": "La organización principal debe resolver a este asesor inactivo."
    },
    "invalidPhone": "Ingrese un número de teléfono válido"
  },
  "description": "El acceso (Acceso al Código de Representante en un usuario) y la designación (qué código de representante representa un contacto de asesor) se resuelven por separado. Use la Vista del Cliente para buscar un cliente y previsualizar los asesores que verá.",
  "clientView": {
    "title": "Vista del Cliente",
    "description": "Busque un cliente, abra sus detalles y luego seleccione una cuenta o un grupo familiar para previsualizar los asesores que verá.",
    "detailDescription": "Elija una cuenta para editar la visibilidad, o un grupo familiar para previsualizar la visibilidad compilada.",
    "search": "Buscar clientes",
    "grainLabel": "Alcance",
    "grainAccount": "Cuenta",
    "grainHousehold": "Grupo familiar",
    "selectAccount": "Seleccionar cuenta",
    "selectHousehold": "Seleccionar grupo familiar",
    "selectScope": "Seleccione una cuenta o un grupo familiar para previsualizar los asesores resueltos.",
    "householdReadOnly": "Para cambiar la visibilidad, cambie al alcance de Cuenta y edite por cuenta.",
    "visibleForAccount": "Visible para esta cuenta",
    "visibleForAccountNamed": "Visible para esta cuenta: {{name}}",
    "visibleForHousehold": "Visible para este grupo familiar",
    "orgWideHide": "Oculto por una regla de toda la organización",
    "scopedOverride": "Esta cuenta anula la regla de toda la organización",
    "notEnabled": "La resolución no está habilitada para esta firma.",
    "toggleFailed": "No se pudo actualizar la visibilidad",
    "emptyList": "Ningún cliente coincide con esta búsqueda.",
    "emptyAccounts": "Este cliente no tiene cuentas para previsualizar.",
    "emptyHouseholds": "Este cliente no está en un grupo familiar para previsualizar.",
    "scopeLoadFailed": "No se pudieron cargar las cuentas o los grupos familiares para este cliente.",
    "accountsTruncated": "Mostrando {{shown}} de {{total}} cuentas. El resto no están en esta lista.",
    "emptyResolution": "Ningún asesor se resuelve para este alcance.",
    "emptyPreview": "Ningún asesor es visible para este cliente para el alcance seleccionado.",
    "missingPlacement": "El Contacto del Asesor no está en la configuración de la página {{pageType}}.",
    "usingOptions": "Usando opciones de la configuración de la página {{pageType}}",
    "pageType": {
      "NON_INDIVIDUAL": "No individual",
      "HOUSEHOLD": "Grupo familiar",
      "INDIVIDUAL": "Persona física"
    },
    "columns": {
      "name": "Nombre",
      "email": "Correo electrónico",
      "id": "ID de Cliente",
      "phone": "Teléfono",
      "displayRole": "Rol de Visualización",
      "identity": "Identidad",
      "note": "Nota",
      "visibleToClient": "Visible para el Cliente",
      "visibleOn": "Visible en"
    },
    "identity": {
      "curated": "Curado",
      "raw": "Crudo"
    },
    "note": {
      "designated": "Contacto de Asesor Designado para el código de representante {{code}}",
      "repCodeHolder": "Tiene el código de representante {{code}}; no hay contacto designado para ese código",
      "grantAccess": "Tiene Acceso de Concesión a este cliente",
      "manual": "Contacto de asesor designado, independiente de la persona (sin usuario vinculado)",
      "hidden": "Oculto para este cliente"
    },
    "preview": {
      "title": "Contacte a su Asesor"
    },
    "sections": {
      "scope": "Alcance",
      "resolvedAdvisors": "Asesores resueltos"
    }
  }
}
